export default __webpack_public_path__ + "static/media/logo-ae-mumzworld.b59fe850.svg";